import { frequencyPeriod, maxWidth, ribbonType, trigger, position, animation, locationStrategy } from '@meta/widget/options'

const settings = {
  position: position.CENTER,
  ribbonType: ribbonType.GIFT,
  ribbonPosition: position.BOTTOM_LEFT,
  ribbonText: '',
  ribbonColor: '#000000',
  ribbonBgColor: '#000000',
  displayCount: 2,
  displayFrequency: 1,
  displayFrequencyPeriod: frequencyPeriod.HOUR,
  closeButton: true,
  closeOnOverlayClick: true,
  closeButtonColor: '#2b2b2b',
  hideMobile: false,
  hideOverlay: false,
  animation: animation.FADE,
  trigger: trigger.AUTO,
  triggerSeconds: 3,
  triggerScrollPercent: 20,
  triggerClickType: '',
  triggerClickTarget: '',
  trafficShare: 0.5,
  locationStrategy: locationStrategy.SHOW_ALL,
  selectedCountries: [],
  selectedCities: []
}

const styling = {
  maxWidth: maxWidth.SMALL,
  backgroundColor: '#FFFFFF',
  backgroundImage: '',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  borderRadius: 0,
}

const steps = [
  {
    id: '',
    contentItems: {},
    contentItemsList: [],
  },
]

export { settings, styling, steps }
